// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"12":"1789f517","122":"e3341351","305":"a8188d6b","382":"e9ccc21e","420":"ac56e4f0","524":"25a8df8c"}[chunkId] + ".chunk.js";
};